import { useEffect, useState } from 'react';
import { fetchReuploadPolicy } from '../services/reuploadPolicy';
import { ReuploadPolicy } from '../types/reuploadPolicy';

export const useReuploadPolicy = () => {
  const [policy, setPolicy] = useState<ReuploadPolicy | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetchReuploadPolicy()
      .then(nextPolicy => {
        if (!cancelled) {
          setPolicy(nextPolicy);
          setError(null);
        }
      })
      .catch(nextError => {
        if (!cancelled) {
          setPolicy(null);
          setError(nextError instanceof Error ? nextError : new Error('Failed to fetch reupload policy'));
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { policy, loading, error };
};
